import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLTLTableAlias extends Layout {
    sourceTableInfo: DataSource;
    tableAliases: Table;
}
